module.exports = __webpack_public_path__ + "img/halo@2x.c49e0e9.webp";